const reduceHistoricalFlowRates = (flowRates => {
  if( flowRates ) {
    return [flowRates[flowRates.length - 1]];
  }
  return undefined;
});

export default reduceHistoricalFlowRates;